// All or portions of this file Copyright © 2019 Amazon Web Services, Inc. or its affiliates or licensors.
// All rights reserved. For full license terms and conditions, please see the LICENSE file at the root of
// this distribution (the "License") or go to https://content.sumerian.amazonaws.com/engine/latest/license.txt.
// All use of the software is governed by the License. All materials are made available on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. Do not remove or modify any license notices.
import ParticleSystemComponent from './components/ParticleSystemComponent';
import ConstantCurve from './curves/ConstantCurve';
import Curve from './curves/Curve';
import LerpCurve from './curves/LerpCurve';
import LinearCurve from './curves/LinearCurve';
import PolyCurve from './curves/PolyCurve';
import Vector3Curve from './curves/Vector3Curve';
import Vector4Curve from './curves/Vector4Curve';
import ParticleSystemComponentHandler from './handlers/ParticleSystemComponentHandler';
import ParticleData from './ParticleData';
import ParticleDebugRenderSystem from './systems/ParticleDebugRenderSystem';
import ParticleSystemSystem from './systems/ParticleSystemSystem';
import ParticleShaderLib from './ParticleShaderLib';

export {
  ParticleSystemComponent,
  ConstantCurve,
  Curve,
  LerpCurve,
  LinearCurve,
  PolyCurve,
  Vector3Curve,
  Vector4Curve,
  ParticleSystemComponentHandler,
  ParticleData,
  ParticleDebugRenderSystem,
  ParticleSystemSystem,
  ParticleShaderLib
};

// Populate window.sumerian
import Namespace from 'core/scriptpack/Namespace';
import * as internal from '.';
import * as api from './api';
Namespace.register('particle', {internal, api});
